import { useEffect, useState } from "react";
import { enqueueSnackbar } from "notistack";
import { errorsMessage } from "../../helpers";
import useLoadingStore from "../../store/loading";
import useModalStore from "../../store/modalStore";
import { api } from "../../services/api";

export function useSimulador() {
  const [open, setOpen] = useState(false);
  const [results, setResults] = useState();
  const [term, setTerm] = useState("");
  const [simulador, setSimulador] = useState({});
  const { setLoadingTable } = useLoadingStore(state => state);
  const { modalOpen, showModal, hideModal } = useModalStore(state => state);

  useEffect(() => {
    getList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleFilter = () => {
    const filters = {};
    if (term?.length > 0) filters.term = term;
    return filters;
  };

  const getList = async (page = 1, limit = 10) => {
    try {
      setLoadingTable(true);

      const { data } = await api.get(`/simuladores`, {
        params: {
          filters: handleFilter(),
          page,
          limit
        }
      });

      setResults(data?.data || {});
    } catch (err) {
      errorsMessage(err, enqueueSnackbar);
    } finally {
      setLoadingTable(false);
    }
  };

  const handleSearch = () => {
    getList();
  };

  const handleOpen = (status = true) => {
    setOpen(status);
    if (!status) setSimulador({});
  };

  const handleEdit = item => {
    setSimulador(item);
    handleOpen();
  };

  const handleShow = item => {
    setSimulador(item);
    showModal();
  };

  const handleClose = () => {
    setSimulador(null);
    hideModal();
  };

  const handleDelete = async () => {
    try {
      await api.delete(`/simuladores/${simulador.Id}`);
      handleClose();
      getList();
      enqueueSnackbar("Registro deletado com sucesso", {
        variant: "success"
      });
    } catch (err) {
      errorsMessage(err, enqueueSnackbar);
    }
  };

  return {
    results,
    term,
    setTerm,
    handleSearch,
    open,
    handleOpen,
    simulador,
    handleEdit,
    getList,
    handleShow,
    modalOpen,
    hideModal,
    handleClose,
    handleDelete
  };
}
